import produce from "immer";

import {
  GEOGRAPHICAL_REGIONS_CONFIG,
  LOADING_STATES,
  USER_TYPES,
} from "lookup";
import { contextConstants } from "context/constants";
import { set } from "lodash";

export const initialState = {
  searchState: {
    basicSearch: false,
    customSearchQuery: "",
    refinementList: {
      userType: [USER_TYPES.FREELANCER],
      "careers.TKSkillsHierarchy": [],
    },
    skills: {
      required: [],
      optional: [],
      reasoning: "",
      aiSkills: [], // restore the ai skills list to rehype tooltip
    },
    TKSkillsHierarchyExp: [],
    placementFilterStr: "",
    locationFilter: {},
    locationFilterStr: "",
    configProps: {},
    previousAdvanceSearchStateStr: "{}",
    yearsOfExperienceFilterStr: "",
    BHStatusFilterStr: "",
    page: 1,
  },
  hits: [],
  hideSkipped: true,
  hideRejected: true,
  hideMatchedAndApplied: true,
  operators: {
    TKSkillsHierarchy: "and",
    "intelProfessions.name": "and",
    "educationRecords.degreeType": "and",
    "knownLanguages.language": "and",
    "assessments.testName": "and",
  },
  disjunctiveFacets: [],
  loadingAISearch: LOADING_STATES.IDLE,
  reRankHitsForJob: {
    id: "",
    isLoading: false,
  },
  isReadyForSearch: false,
  pageIsLoaded: false,
  geographicalRegions: GEOGRAPHICAL_REGIONS_CONFIG,
};

export const reducer = produce((draft, action) => {
  const { type, payload } = action;

  switch (type) {
    case contextConstants.search.SEARCH_STATE_CHANGED: {
      draft.searchState = payload.searchState;
      break;
    }

    case contextConstants.search.SKILL_SEARCH_STATE_CHANGED: {
      draft.searchState.skills = payload.skills;
      break;
    }

    case contextConstants.search.READY_FOR_SEARCH_CHANGED: {
      draft.isReadyForSearch = payload.value;
      break;
    }

    case contextConstants.search.PAGE_IS_LOADED_CHANGED: {
      draft.pageIsLoaded = payload.value;
      break;
    }

    case contextConstants.search.RE_RANK_HITS_FOR_JOB_CHANGED: {
      if (payload.fieldKey) {
        set(draft.reRankHitsForJob, payload.fieldKey, payload.value);

        break;
      }

      draft.reRankHitsForJob = payload.value;

      break;
    }

    case contextConstants.search.HITS_LOADED: {
      draft.hits = payload.hits;
      break;
    }

    case contextConstants.search.DISJUNCTIVE_FACETS_CHANGED: {
      draft.disjunctiveFacets = payload.disjunctiveFacets;
      break;
    }

    case contextConstants.search.OPERATOR_UPDATED: {
      draft.operators = payload.operators;
      break;
    }

    case contextConstants.search.HIDE_SKIPPED_CHANGED: {
      draft.hideSkipped = payload.hideSkipped;
      break;
    }

    case contextConstants.search.HIDE_REJECTED_CHANGED: {
      draft.hideRejected = payload.hideRejected;
      break;
    }

    case contextConstants.search.HIDE_MATCHED_CHANGED: {
      draft.hideMatchedAndApplied = payload.hideMatchedAndApplied;
      break;
    }

    case contextConstants.search.GEOGRAPHICAL_REGION_CHANGED: {
      draft.geographicalRegions = payload.geographicalRegions;
      break;
    }

    case contextConstants.search.LOCATION_FILTER_CHANGED: {
      draft.searchState.locationFilter = payload.locationFilter;
      draft.searchState.locationFilterStr = payload.locationFilterStr;
      break;
    }

    case contextConstants.search.COUNTRY_REFINEMENT_CHANGED: {
      draft.searchState.refinementList["location.countryName"] =
        payload.countries;
      break;
    }

    case contextConstants.search.LOADING_AI_SEARCH_CHANGED: {
      draft.loadingAISearch = payload.loadingAISearch;
      break;
    }

    default:
      break;
  }
});
